import { render, staticRenderFns } from "./colorModel.vue?vue&type=template&id=71117e65&scoped=true"
import script from "./colorModel.vue?vue&type=script&lang=js"
export * from "./colorModel.vue?vue&type=script&lang=js"
import style0 from "./colorModel.vue?vue&type=style&index=0&id=71117e65&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71117e65",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71117e65')) {
      api.createRecord('71117e65', component.options)
    } else {
      api.reload('71117e65', component.options)
    }
    module.hot.accept("./colorModel.vue?vue&type=template&id=71117e65&scoped=true", function () {
      api.rerender('71117e65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/configure/components/colorModel.vue"
export default component.exports